<form>
  <div mat-dialog-content class="calibrates-theme">
    <div fxLayout="column" class="flexwrap">
      <div fxFlex>
        @for (value of dataPoints; track value; let indexValue = $index) {
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
            >
            <div fxFlex="10" style="padding-top: 1em;">
              <mat-checkbox name="include{{indexValue}}" color="primary" [checked]="value.include"
                (change)="setValue(indexValue, $event, 'include')">
              </mat-checkbox>
            </div>
            <div fxFlex="15" fxFlex.lt-md="95%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.number.label' | translate
                }}</mat-label>
                <input matInput name="num{{indexValue}}" [ngModel]="indexValue + 1" disabled>
              </mat-form-field>
            </div>
            <div fxFlex="20" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.value.label' | translate
                }}</mat-label>
                <input matInput type="number" name="value{{indexValue}}" [ngModel]="value.value" disabled>
                <mat-error>
                  {{ 'calibrateEquipmentEdit.patterns.dialog.values.value.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()"
    cdkFocusInitial>{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>
</form>